const BotAuxMsg = {
    regular: [
        "Hey,",
        "Hi,",
        "Hi...",
        "Hey..",
    ],
    bad_mood: [
        "Unfortunately,",
        "So.. Apologies..",
        "Oops!",
        "Apologies..",
        "Excuse me...",
        "Please.."
    ],
    damage_control: [
        "My bad!",
        "Apologies!",
    ],
    emotions: {
        bad: [
            "&#x1F644;",
            "&#x1F623;",
            "&#x1F614;",
            "&#x1F641;",
            "&#x1F61E;",
            ""
        ]
    }
    

}

export default BotAuxMsg;